import { compareAsc, format, getDay, getMonth, getYear } from "date-fns";
import "./calendar.css";
import { setDays, weekdays, months } from "./data";
import { useState, useEffect } from "react";
import arrowRight from "../../picture/play-right.png";
import arrowLeft from "../../picture/play-left.png";
import bellGreen from "../../picture/bell-green.png"; // Green bell image
import bellRed from "../../picture/bell-red.png"; // Red bell image

const Calendar = () => {
  const [selectedDay, setSelectedDay] = useState(
    new Date(new Date().setHours(0, 0, 0, 0))
  );
  const [currentDays, setCurrentDays] = useState(setDays(new Date()));
  const [notifications, setNotifications] = useState({
    // Moze Data objekat is data-fns
    "2024-12-07": [{ text: "Doctor's appointment", seen: true }],
    "2024-12-16": [{ text: "Meeting at 10 AM", seen: false }],
    "2024-12-22": [{ text: "Doctor's appointment", seen: true }],
  });

  const renderEmpty = (cond) => {
    const firstDay = getDay(currentDays[0]); // Get day of the week (0 = Sunday, 6 = Saturday)
    const index = cond
      ? (firstDay === 0 ? 6 : firstDay - 1) // Adjust for Monday as the first day
      : 6 - (getDay(currentDays[currentDays.length - 1]) === 0 ? 6 : getDay(currentDays[currentDays.length - 1]) - 1);
  
    if (index === 0) return null;
    let array = Array.from({ length: index });
    return array.map((_, index) => {
      return <div className="calendar-main-item" key={index}></div>;
    });
  };

  const setFontSizes = () => {
    const headerSpans = document
      .getElementById("header")
      .querySelectorAll("span");
    const dateSpans = document.querySelectorAll(".calendar-main-item.letter");
    const header = document
      .querySelector(".calendar-main-item")
      .getBoundingClientRect();
    const tableCells = document.querySelectorAll(".calendar-main-item");
    const table = document.querySelector(".calendar-main");

    if (table !== undefined && table !== null) {
      const tableDim = table.getBoundingClientRect();

      headerSpans.forEach(
        (span) => (span.style.fontSize = `${header.height * 0.8}px`)
      );
      tableCells.forEach(
        (tc) => (tc.style.fontSize = `${(tableDim.height / 7) * 0.6}px`)
      );
      dateSpans.forEach(
        (span) => (span.style.fontSize = `${header.height * 0.9}px`)
      );
    }
  };
const handleNextMonth = () => {
  let newDate;
  if (getMonth(selectedDay) + 1 === 12)
    newDate = new Date(`${getYear(selectedDay) + 1}-1-1`);
  else {
    newDate = new Date(
      `${getYear(selectedDay)}-${getMonth(selectedDay) + 2}-1`
    );
  }

  if (
    getMonth(newDate) === getMonth(new Date()) &&
    getYear(newDate) === getYear(new Date())
  ) {
    // Reset selectedDay to today if navigating back to the current month
    setSelectedDay(new Date(new Date().setHours(0, 0, 0, 0)));
  } else {
    setSelectedDay(newDate);
  }

  setCurrentDays(setDays(newDate));
};

const handlePreviousMonth = () => {
  let newDate;
  if (getMonth(selectedDay) - 1 === -1)
    newDate = new Date(`${getYear(selectedDay) - 1}-12-1`);
  else {
    newDate = new Date(
      `${getYear(selectedDay)}-${
        getMonth(selectedDay) - 1 !== 0 ? getMonth(selectedDay) : "1"
      }-1`
    );
  }

  if (
    getMonth(newDate) === getMonth(new Date()) &&
    getYear(newDate) === getYear(new Date())
  ) {
    // Reset selectedDay to today if navigating back to the current month
    setSelectedDay(new Date(new Date().setHours(0, 0, 0, 0)));
  } else {
    setSelectedDay(newDate);
  }

  setCurrentDays(setDays(newDate));
};


  const handleSelectedDay = (selected) => {
    setSelectedDay(selected);
  };

  const checkIfSelected = (day) => {
    return compareAsc(day, selectedDay) === 0;
  };

  const formatDateKey = (date) => {
    return format(date, "yyyy-MM-dd");
  };

  const markNotificationsAsSeen = (dateKey) => {
    if (notifications[dateKey]) {
      const updatedNotifications = { ...notifications };
      updatedNotifications[dateKey] = updatedNotifications[dateKey].map(
        (notification) => ({ ...notification, seen: true })
      );
      setNotifications(updatedNotifications);
    }
  };

  useEffect(() => {
    setFontSizes();
  }, [currentDays]);

  useEffect(() => {
    window.addEventListener("resize", setFontSizes);
    return () => window.removeEventListener("resize", setFontSizes);
  }, []);

  return (
    <div className="calendar-custom">
      <div className="calendar-custom-header">
        <img
          src={arrowLeft}
          alt=""
          className="calendar-custom-header-left"
          onClick={handlePreviousMonth}
        />
        <div id="header" className="calendar-custom-header-date">
          <span className="month">{months[getMonth(selectedDay)]}</span>
          <span className="line">-</span>
          <span className="year">{getYear(selectedDay)}</span>
        </div>
        <img
          src={arrowRight}
          alt=""
          className="calendar-custom-header-right"
          onClick={handleNextMonth}
        />
      </div>
      <div className="calendar-custom-main">
        {weekdays.map((day, index) => (
          <span key={index} className="calendar-custom-main-item letter">
            {day}
          </span>
        ))}
        {renderEmpty(true)}
        {currentDays.map((day, index) => {
          const dayKey = formatDateKey(day);
          const hasNotification = notifications[dayKey]?.length > 0;
          const allSeen =
            hasNotification &&
            notifications[dayKey].every((notification) => notification.seen);

          return (
            <div
              className={
                checkIfSelected(day)
                  ? "calendar-custom-main-item active selected"
                  : "calendar-custom-main-item active"
              }
              key={index}
            >
              <span
                className="calendar-custom-main-item-day"
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  width: "100%",
                }}
              >
                {format(day, "d").toString().length === 1
                  ? `0${format(day, "d")}`
                  : format(day, "d")}
                {hasNotification && (
                  <img
                    src={allSeen ? bellGreen : bellRed}
                    style={{ height: "20px" }}
                    alt="Notification Bell"
                  />
                )}
              </span>
            </div>
          );
        })}
        {renderEmpty(false)}
      </div>
    </div>
  );
};

export default Calendar;
